<template>
  <div class="home-view py-4">
    <home-slider-component />
    <home-tiles-menu />
  </div>
</template>

<script>
import HomeSliderComponent from "@/components/home/HomeSliderComponent.vue";
import HomeTilesMenu from "@/components/home/HomeTilesMenu.vue";
import { onMounted } from "vue";
import { useStore } from "vuex";
import ProductService from "@/services/ProductService";
import { mutationTypes } from "@/store";
import { mutationTypes as shopMutationTypes } from "@/store/modules/shop";

export default {
  name: "HomeView",
  components: {
    HomeSliderComponent,
    HomeTilesMenu,
  },
  setup() {
    const store = useStore();
    const Product = new ProductService();

    const setSpinner = (payload) =>
      store.commit(mutationTypes.SET_SPINNER, payload);
    const setProducts = (payload) =>
      store.commit(`shop/${shopMutationTypes.SET_PRODUCTS}`, payload);
    const setCategories = (payload) =>
      store.commit(`shop/${shopMutationTypes.SET_CATEGORIES}`, payload);

    const getData = async () => {
      setSpinner(true);
      try {
        const [productsRes, categoriesRes] = await Promise.all([
          Product.fetch(),
          Product.fetchCategories(),
        ]);

        if (
          productsRes.status === 200 &&
          categoriesRes.status === 200 &&
          productsRes.data &&
          categoriesRes.data
        ) {
          setProducts(productsRes.data);
          setCategories(categoriesRes.data);
        }
      } catch (e) {
        console.error(
          "❌ Проблема з завантаженням продуктів або категорій:",
          e
        );
      } finally {
        setSpinner(false);
      }
    };

    onMounted(() => {
      getData();
    });

    return {
      // nothing to expose
    };
  },
};
</script>

<style scoped lang="less"></style>
